import { ColorScheme } from "./color_scheme.js";

export class TextStyleScheme
{
  static geologica = "Geologica, 'Arial Black', Arial, sans-serif";

  // Canonical button-label drop shadow, matching the main menu PLAY button
  // and the shop buy button: X:0 Y:3 blur:5, 50%-opacity black.
  static buttonShadow(): { shadow_blur: number; shadow_color: string; shadow_offset_x: number; shadow_offset_y: number }
  {
    return {
      shadow_blur: LayoutScaler.widthFromDesign( 8 ),
      shadow_color: ColorScheme.black_transparent,
      shadow_offset_x: LayoutScaler.xFromDesign( 0 ),
      shadow_offset_y: LayoutScaler.yFromDesign( 5 ),
    };
  }

  static timerShadow(): { shadow_blur: number; shadow_color: string; shadow_offset_x: number; shadow_offset_y: number }
  {
    return {
      shadow_blur: LayoutScaler.widthFromDesign( 5 ),
      shadow_color: ColorScheme.black_transparent,
      shadow_offset_x: LayoutScaler.xFromDesign( 0 ),
      shadow_offset_y: LayoutScaler.yFromDesign( 3 ),
    };
  }
}
